import { useState, type ReactNode } from "react";
import { avatarFarbe, initialen } from "../lib/mobil";

/**
 * Absender-Avatar: Firmenlogo, wenn der Server eins findet, sonst Initialen
 * in einer festen Farbe je Adresse. Das Logo holt der Server (siehe
 * packages/core/src/logos.ts) — der Browser fragt nie die fremde Seite.
 */

// Adressen ohne Logo merken, damit beim Blättern nichts flackert und nicht
// jede Zeile erneut fragt. Der Browser behält das 404 zusätzlich einen Tag.
const ohneLogo = new Set<string>();
const mitLogo = new Set<string>();

export function Avatar({ email, name, eigene, groesse = "m", children, className }: {
  email: string;
  name: string;
  /** Eigene Nachricht: „Du" statt Logo. */
  eigene?: boolean;
  groesse?: "s" | "m" | "l";
  /** Ersetzt den Inhalt, z. B. den Haken bei Mehrfachauswahl. */
  children?: ReactNode;
  className?: string;
}) {
  const schluessel = email.toLowerCase();
  const [fehlt, setFehlt] = useState(() => ohneLogo.has(schluessel));
  const [geladen, setGeladen] = useState(() => mitLogo.has(schluessel));
  const logo = !eigene && !children && schluessel.includes("@") && !fehlt;

  return (
    <span
      className={`avatar${className ? ` ${className}` : ""}`}
      data-groesse={groesse}
      data-logo={logo && geladen ? "true" : undefined}
      data-eigene={eigene || undefined}
      style={{ ["--avatar-farbe" as string]: avatarFarbe(schluessel || name) }}
      aria-hidden="true"
    >
      {children ?? (
        <>
          <span className="avatar-initialen">{eigene ? "Du" : initialen(name || email)}</span>
          {logo && (
            <img
              src={`/api/logo/${encodeURIComponent(schluessel)}`}
              alt=""
              loading="lazy"
              decoding="async"
              onLoad={() => { mitLogo.add(schluessel); setGeladen(true); }}
              onError={() => { ohneLogo.add(schluessel); setFehlt(true); }}
            />
          )}
        </>
      )}
    </span>
  );
}
